import { Stack, Stepper } from "@mantine/core";
import { useMemo } from "react";
import { useLanguage } from "../../../../../../../stores/LanguageStore";
import { useLeadsSheetStore } from "../../../../../../../stores/LeadsStore";
import SummaryGroup from "./SummaryGroup";
import SummaryItem from "./SummaryItem";

const TabSummary = () => {
  const lang = useLanguage((s) => s.language);
  const current = useLeadsSheetStore((s) => s.current);

  let historyCreatedOn = {
    history_type: "creation",
    date: current?.created_on,
    event: "email_open",
    workflow_step_id: 0,
    workflow_programmation_id: 0,
    contact_list_id: current?.fromContactList,
  };

  const campaignActivities = useMemo(() => {
    if (!current?.programmations && !current?.history) {
      return [];
    }

    const programmations = current?.programmations || [];
    let history = current?.history || [];
    history.push(
      ...(current?.calls?.map((call) => ({
        ...call,
        date: call.call_date,
        history_type: "call",
      })) || [])
    );

    const mapped = programmations
      .sort((a, b) => b.programmation_id - a.programmation_id)
      .map((prog) => {
        return {
          ...prog,
          history: history
            .filter((x) => {
              if (x?.history_type === "sent") {
                if (!x?.workflow_programmation_id || !x?.workflow_step_id) {
                  return true;
                } else {
                  return false;
                }
              }
              if (x?.workflow_programmation_id === prog.programmation_id) {
                return true;
              }
              if (x?.history_type === "note") {
                return true;
              }
              return false;
            })
            .sort((a, b) => new Date(b?.date) - new Date(a?.date)),
        };
      });

    const matchedIds = new Set(programmations.map((p) => p.programmation_id));
    const unlinkedHistory = history.filter(
      (x) =>
        !matchedIds.has(x?.workflow_programmation_id) &&
        x?.history_type !== "note"
    );

    if (unlinkedHistory.length > 0) {
      mapped.push({
        programmation_id: null,
        name: "Unlinked Activities", // or any label you want
        history: unlinkedHistory,
      });
    }

    return mapped;
  }, [current]);

  // const filters = useMemo(() => {
  //   return [
  //     {
  //       label: lang.prm.details.filters.notes,
  //       value: "note",
  //     },
  //     {
  //       label: lang.prm.details.filters.replies,
  //       value: "reply",
  //     },
  //     {
  //       label: lang.prm.details.filters.sent,
  //       value: "sent",
  //     },
  //     {
  //       label: lang.prm.details.filters.events,
  //       value: "event",
  //     },
  //   ];
  // }, [
  //   lang.prm.details.filters.events,
  //   lang.prm.details.filters.notes,
  //   lang.prm.details.filters.replies,
  //   lang.prm.details.filters.sent,
  // ]);
  // const orders = useMemo(() => {
  //   return [
  //     {
  //       label: lang.prm.details.filters.desc,
  //       value: "desc",
  //     },
  //     {
  //       label: lang.prm.details.filters.asc,
  //       value: "asc",
  //     },
  //   ];
  // }, [lang.prm.details.filters.asc, lang.prm.details.filters.desc]);

  return (
    <Stack
      gap={0}
      flex={1}
      h={0}
      mih={"100%"}
      style={{ overflow: "auto" }}
      p={"lg"}
      px={0}
    >
      {/* <Group mb={16}>
        <Select
          value={sort}
          data={orders}
          w={200}
          size="xs"
          onChange={setSort}
          leftSection={
            sort === "asc" ? (
              <IconArrowUp size={18} />
            ) : (
              <IconArrowDown size={18} />
            )
          }
        />
        <Select
          placeholder={lang.prm.details.filters.filter}
          data={filters}
          onChange={handleFilterChange}
          w={100}
          size="xs"
          clearable
        />
      </Group> */}

      {campaignActivities.map((campaign, index) => (
        <SummaryGroup
          key={campaign.programmation_id}
          campaign={campaign}
          isFirst={index === 0}
        />
      ))}

      <Stepper
        active={0}
        iconSize={28}
        mt={16}
        size="sm"
        radius={"lg"}
        styles={{ stepIcon: { border: "none", background: "none" } }}
        orientation="vertical"
      >
        <SummaryItem
          item={historyCreatedOn}
          isLast={true}
          // isOutside={!!outside}
        />
      </Stepper>
    </Stack>
  );
};

export default TabSummary;
